PHI.productlisting = {

  bind: function() {
    // Only run this code when the page supports the image selector
    if ($('#nonImageModeSelector').length === 0) {
      return;
    }

    this.setInitialValue();
    $('#showImage').change(function() {
      this.toggleImages(true);
    }.bind(this));

    $('#hideImage').change(function() {
      this.toggleImages(false);
    }.bind(this));
  },

  setInitialValue: function() {
    var showImage = this.loadFromMemory();

    if (showImage) {
      $('#showImage').prop('checked', true);
    } else {
      $('#hideImage').prop('checked', true);
      $('#resultsList').toggleClass('no-images', true);
      $('#resultsList .summary').toggleClass('no_image_height', true);
      $('.add_to_cart_form').toggleClass('move_form', true);
      $('.addToCartButton').toggleClass('button_change', true);
      $('.product-item').toggleClass('product-item-less', true);
    }
  },

  loadFromMemory: function() {
    var showImage = true;

    if (localStorage.getItem('listing.showImage')) {
      showImage = localStorage.getItem('listing.showImage') === 'true';
    }

    return showImage;
  },

  toggleImages: function(show) {
    $('#resultsList').toggleClass('no-images', !show);

    $('.product-item').toggleClass('product-item-less', !show);
    $('#resultsList .summary').toggleClass('no_image_height', !show);
    $('.add_to_cart_form').toggleClass('move_form', !show);
    $('.addToCartButton').toggleClass('button_change', !show);

    localStorage.setItem('listing.showImage', show);
  }
};

$(function() {
  PHI.productlisting.bind();
});
